import { render, staticRenderFns } from "./receive-detail.vue?vue&type=template&id=e584b0a4"
import script from "./receive-detail.vue?vue&type=script&lang=js"
export * from "./receive-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports